import { render, staticRenderFns } from "./ContestCriteriaFormComponent.vue?vue&type=template&id=52af4646"
import script from "./ContestCriteriaFormComponent.vue?vue&type=script&lang=js"
export * from "./ContestCriteriaFormComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestCriteriaFormComponent.vue?vue&type=style&index=0&id=52af4646&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports